/* ============================================================
   ATC Upsell Popup — reemplazo nativo de Selleasy.

   Escucha 'cart:item-added' (ya lo dispara product-form.js y los
   order-bumps). Si el producto agregado matchea un trigger, muestra
   un popup de upsell EN LUGAR de abrir el cart drawer.

   NO usa all_products en Liquid: el producto ofertado se resuelve en
   runtime con /products/<handle>.js, así que no consume el cupo de 20
   lookups por template y los precios nunca quedan viejos.

   Agregar al carrito desde el popup no requiere estar en la PDP del
   producto ofertado: alcanza con su variant id (POST /cart/add.js).

   Descuento (config.mode):
     'auto'    → no toca nada. El 50% lo aplica un descuento automático
                 "Compra X, llevá Y con 50%" creado en el admin.
                 Sin redundancia: no duplica producto ni variante.
     'code'    → aplica un código oculto vía /discount/<CODE> antes de
                 agregar (exclusivo del popup, no publicado).
     'variant' → agrega una variante dedicada ya rebajada
                 (offer.variantId apunta a esa variante).

   Buildless: script clásico, sin imports.
   ============================================================ */
(function () {
  'use strict';

  var ROOT = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/$/, '');
  var ADD_URL = ROOT + '/cart/add.js';
  var CART_URL = ROOT + '/cart.js';
  var SESSION_KEY = 'atcUpsellShown';

  var cfg = null;
  var root = null;
  var els = {};
  var current = null; // { offer, variantId, priceText, compareText }
  var timerId = null;
  var drawerPatched = false;
  var suppressDrawer = false;
  var productCache = {};

  /* Idioma: el motor casero (i18n.js) guarda la preferencia en localStorage.lang;
     html[lang] es sólo el fallback. Toda la copy del popup viaja en el config,
     así no compite con el swap de data-i18n. */
  function lang() {
    var l = '';
    try { l = localStorage.getItem('lang') || ''; } catch (e) {}
    if (!l) l = document.documentElement.lang || 'es';
    return String(l).toLowerCase().indexOf('en') === 0 ? 'en' : 'es';
  }

  function copyOf(offer) {
    var c = offer.copy || {};
    return c[lang()] || c.es || c.en || {};
  }

  function T() {
    return lang() === 'en'
      ? { error: "We couldn't add it. Try again." }
      : { error: 'No pudimos agregarlo. Probá de nuevo.' };
  }

  /* ---------------- helpers ---------------- */

  function q(sel) { return root ? root.querySelector(sel) : null; }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Formateo de dinero al estilo Shopify, usando shop.money_format del config. */
  function formatMoney(cents, format) {
    var fmt = format || cfg.moneyFormat || '${{amount}}';
    fmt = String(fmt).replace(/<[^>]*>/g, '');
    var value = Number(cents) || 0;

    function pad(num, size) {
      var s = String(num);
      while (s.length < size) s = '0' + s;
      return s;
    }
    function thousands(num, sep) {
      return num.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + sep);
    }
    function build(precision, thousandSep, decimalSep) {
      var num = (value / 100).toFixed(precision);
      var parts = num.split('.');
      return thousands(parts[0], thousandSep) + (precision ? decimalSep + pad(parts[1], precision) : '');
    }

    var placeholder = /\{\{\s*(\w+)\s*\}\}/.exec(fmt);
    var key = placeholder ? placeholder[1] : 'amount';
    var out;
    switch (key) {
      case 'amount_no_decimals': out = build(0, ',', '.'); break;
      case 'amount_with_comma_separator': out = build(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = build(0, '.', ','); break;
      case 'amount_with_apostrophe_separator': out = build(2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': out = build(0, ' ', ','); break;
      case 'amount_with_space_separator': out = build(2, ' ', ','); break;
      default: out = build(2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, out);
  }

  function getCartUI() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  /* El drawer se abre solo dentro de renderContents(). Para mostrar el popup
     EN LUGAR del drawer, parcheamos open() en la instancia. El custom element
     sobrevive a renderContents (sólo se reemplaza el innerHTML de #CartDrawer). */
  function patchDrawer() {
    var cart = getCartUI();
    if (!cart || drawerPatched || typeof cart.open !== 'function') return;
    var nativeOpen = cart.open.bind(cart);
    cart.__atcuNativeOpen = nativeOpen;
    cart.open = function (triggeredBy) {
      if (suppressDrawer) return;
      return nativeOpen(triggeredBy);
    };
    drawerPatched = true;
  }

  function openDrawer() {
    var cart = getCartUI();
    suppressDrawer = false;
    if (!cart) return;
    if (typeof cart.__atcuNativeOpen === 'function') cart.__atcuNativeOpen();
    else if (typeof cart.open === 'function') cart.open();
  }

  function alreadyShown() {
    try { return sessionStorage.getItem(SESSION_KEY) === '1'; } catch (e) { return false; }
  }
  function markShown() {
    try { sessionStorage.setItem(SESSION_KEY, '1'); } catch (e) {}
  }

  function getProduct(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch(ROOT + '/products/' + handle + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(function (r) {
        if (!r.ok) throw new Error('product ' + handle + ' ' + r.status);
        return r.json();
      })
      .then(function (p) { productCache[handle] = p; return p; });
  }

  /* ---------------- render ---------------- */

  var ICON_FOLDER =
    '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<path d="M3.5 8.2A2.2 2.2 0 0 1 5.7 6h4.1l1.6 1.7h7.1A2.2 2.2 0 0 1 20.7 10v7.3a2.2 2.2 0 0 1-2.2 2.2H5.7A2.2 2.2 0 0 1 3.5 17.3V8.2Z" fill="currentColor" opacity=".18"/>' +
    '<path d="M3.5 8.2A2.2 2.2 0 0 1 5.7 6h4.1l1.6 1.7h7.1A2.2 2.2 0 0 1 20.7 10v7.3a2.2 2.2 0 0 1-2.2 2.2H5.7A2.2 2.2 0 0 1 3.5 17.3V8.2Z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/>' +
    '</svg>';

  function renderFolders(list) {
    if (!els.track) return;
    var names = (list || []).slice(0, 30);
    if (!names.length) { els.track.innerHTML = ''; return; }
    var html = '';
    // duplicado: el marquee vertical hace translateY(-50%) sin costura
    for (var pass = 0; pass < 2; pass++) {
      for (var i = 0; i < names.length; i++) {
        var idx = i + 1 < 10 ? '0' + (i + 1) : String(i + 1);
        html +=
          '<li class="atcu__folder">' + ICON_FOLDER +
          '<span class="atcu__folder-name">' + esc(names[i]) + '</span>' +
          '<span class="atcu__folder-idx" aria-hidden="true">' + idx + '</span>' +
          '</li>';
      }
    }
    els.track.innerHTML = html;
  }

  var CHECK =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';

  function setText(el, value) { if (el) el.textContent = value == null ? '' : value; }

  function fill(state) {
    var o = state.offer;
    var c = copyOf(o);
    var hasChoices = !!(state.choices && state.choices.length);

    root.classList.toggle('atcu--choices', hasChoices);

    setText(els.addedLabel, c.addedLabel);
    setText(els.triggerTitle, state.triggerTitle);
    if (els.triggerImg) {
      if (state.triggerImage) { els.triggerImg.src = state.triggerImage; els.triggerImg.hidden = false; }
      else { els.triggerImg.hidden = true; }
    }
    setText(els.eyebrow, c.eyebrow);
    if (els.title) els.title.innerHTML = c.titleHtml || esc(c.title || '');
    if (els.cover) {
      if (state.offerImage) {
        els.cover.src = state.offerImage;
        els.cover.alt = state.offerTitle;
        els.cover.hidden = false;
      } else {
        els.cover.hidden = true;
        els.cover.removeAttribute('src');
        els.cover.alt = '';
      }
    }
    if (els.choices) {
      els.choices.hidden = !hasChoices;
      if (hasChoices) renderChoices(state);
      else els.choices.innerHTML = '';
    }
    if (els.lib) els.lib.hidden = hasChoices;
    setText(els.libPath, c.libPath);
    setText(els.libMeta, c.libMeta);
    if (els.compare) {
      setText(els.compare, state.compareText);
      els.compare.hidden = !state.compareText;
    }
    setText(els.price, state.priceText);
    if (els.badge) {
      setText(els.badge, o.badge);
      els.badge.hidden = !o.badge;
    }
    setText(els.timerLabel, c.timerLabel);
    setText(els.ctaLabel, c.ctaLabel);
    setText(els.ctaPrice, state.priceText);
    setText(els.decline, c.declineLabel);
    if (els.close) els.close.setAttribute('aria-label', c.closeLabel || 'Cerrar');
    if (els.trust) {
      els.trust.innerHTML = (c.trust || [])
        .map(function (t) { return '<li>' + CHECK + esc(t) + '</li>'; })
        .join('');
    }
    renderFolders(c.folders || o.folders);
  }

  function renderChoices(state) {
    if (!els.choices) return;
    var c = copyOf(state.offer);
    var selected = state.selectedChoice || state.choices[0];
    els.choices.setAttribute('aria-label', c.choiceLabel || 'Elegir');
    els.choices.innerHTML = state.choices.map(function (choice, index) {
      var active = selected && String(choice.variantId) === String(selected.variantId);
      return '<button type="button" class="atcu__choice' + (active ? ' is-selected' : '') + '"' +
        ' data-atcu-choice data-choice-index="' + index + '" role="radio" aria-checked="' + active + '">' +
        '<span class="atcu__choice-check" aria-hidden="true">' + CHECK + '</span>' +
        '<span class="atcu__choice-cover-wrap"><img class="atcu__choice-cover" src="' + esc(choice.offerImage) +
        '" alt="" width="240" height="240"></span>' +
        '<span class="atcu__choice-title">' + esc(choice.shortTitle || choice.offerTitle) + '</span>' +
        '<span class="atcu__choice-prices"><s>' + esc(choice.compareText) + '</s><b>' + esc(choice.priceText) + '</b></span>' +
        '</button>';
    }).join('');
  }

  function selectChoice(index) {
    if (!current || !current.choices || !current.choices[index]) return;
    current.selectedChoice = current.choices[index];
    var selected = current.selectedChoice;
    if (els.compare) {
      setText(els.compare, selected.compareText);
      els.compare.hidden = !selected.compareText;
    }
    setText(els.price, selected.priceText);
    setText(els.ctaPrice, selected.priceText);
    renderChoices(current);
  }

  /* ---------------- timer ---------------- */

  function startTimer(seconds) {
    stopTimer();
    if (!seconds || !els.clock) {
      if (els.timer) els.timer.hidden = true;
      return;
    }
    if (els.timer) els.timer.hidden = false;
    var left = seconds;
    var tick = function () {
      var m = Math.floor(left / 60);
      var s = left % 60;
      els.clock.textContent = m + ':' + (s < 10 ? '0' + s : s);
      if (left <= 0) { stopTimer(); close(); return; }
      left--;
    };
    tick();
    timerId = setInterval(tick, 1000);
  }
  function stopTimer() { if (timerId) { clearInterval(timerId); timerId = null; } }

  /* ---------------- open / close ---------------- */

  var lastFocus = null;

  function open(state) {
    current = state;
    fill(state);
    if (els.err) els.err.hidden = true;
    lastFocus = document.activeElement;
    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    void root.offsetWidth; // reflow: la transición arranca del estado inicial
    root.classList.add('is-open');
    startTimer(cfg.timerSeconds);
    markShown();
    if (els.cta) els.cta.focus({ preventScroll: true });
    document.addEventListener('keydown', onKeydown, true);
    document.dispatchEvent(new CustomEvent('atc-upsell:shown', { detail: state, bubbles: true }));
  }

  function close(opts) {
    if (!root || root.hidden) return;
    stopTimer();
    root.classList.remove('is-open');
    document.removeEventListener('keydown', onKeydown, true);
    document.body.style.overflow = '';
    setTimeout(function () {
      root.hidden = true;
      root.setAttribute('aria-hidden', 'true');
      if (lastFocus && typeof lastFocus.focus === 'function') {
        try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
      }
      if (!opts || opts.openDrawer !== false) openDrawer();
    }, 260);
  }

  function onKeydown(e) {
    if (e.key === 'Escape') { e.stopPropagation(); decline(); return; }
    if (e.key !== 'Tab') return;
    var f = root.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var first = f[0];
    var last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------------- aceptar / rechazar ---------------- */

  function applyDiscountCode(code) {
    if (!code) return Promise.resolve();
    // /discount/<CODE> setea la cookie de descuento del carrito sin navegar.
    return fetch(ROOT + '/discount/' + encodeURIComponent(code), {
      method: 'GET',
      credentials: 'same-origin',
    }).catch(function () { /* si falla, seguimos: el add no debe romperse */ });
  }

  function accept() {
    if (!current || !els.cta) return;
    els.cta.setAttribute('aria-busy', 'true');
    if (els.err) els.err.hidden = true;

    var selected = current.selectedChoice || current;
    var selectedConfig = selected.choice || current.offer;
    var mode = selectedConfig.mode || current.offer.mode || cfg.mode;
    var discountCode = selectedConfig.discountCode || current.offer.discountCode || cfg.discountCode;
    var pre = mode === 'code' ? applyDiscountCode(discountCode) : Promise.resolve();

    pre
      .then(function () {
        var item = { id: parseInt(selected.variantId, 10), quantity: 1 };
        var properties = selectedConfig.properties || current.offer.properties;
        if (properties) item.properties = properties;
        return fetch(ADD_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({
            items: [item],
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname,
          }),
        });
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.status && data.status !== 200) {
          throw new Error(data.description || data.message || T().error);
        }
        var cart = getCartUI();
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: 'atc-upsell-popup',
            productVariantId: String(selected.variantId),
            cartData: data,
          });
        }
        document.dispatchEvent(
          new CustomEvent('atc-upsell:accepted', {
            detail: { offer: current.offer, choice: selectedConfig, variantId: selected.variantId, cartData: data },
            bubbles: true,
          })
        );
        suppressDrawer = true; // que renderContents no abra el drawer todavía
        if (cart && typeof cart.renderContents === 'function' && data.sections) {
          cart.renderContents(data);
        }
        close(); // close() reabre el drawer ya actualizado
      })
      .catch(function (err) {
        console.error('[atc-upsell]', err);
        if (els.err) {
          els.err.textContent = (err && err.message) || T().error;
          els.err.hidden = false;
        }
      })
      .finally(function () {
        if (els.cta) els.cta.removeAttribute('aria-busy');
      });
  }

  function decline() {
    document.dispatchEvent(
      new CustomEvent('atc-upsell:declined', {
        detail: { offer: current ? current.offer : null },
        bubbles: true,
      })
    );
    close();
  }

  /* ---------------- trigger ---------------- */

  function matches(offer, item) {
    if (!item) return false;
    var ids = (offer.triggerVariantIds || []).map(String);
    if (ids.length && ids.indexOf(String(item.variant_id)) !== -1) return true;
    var handles = offer.triggerHandles || [];
    return handles.indexOf(item.handle) !== -1;
  }

  function cartHasAny(cart, keys) {
    if (!cart || !cart.items || !keys || !keys.length) return false;
    var set = keys.map(String);
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (set.indexOf(String(it.variant_id)) !== -1) return true;
      if (set.indexOf(String(it.product_id)) !== -1) return true;
      if (it.handle && set.indexOf(it.handle) !== -1) return true;
    }
    return false;
  }

  /* Resuelve variante + precios de la oferta y arma el estado a mostrar. */
  function buildState(offer, cart, addedItem) {
    function resolveProduct(item) {
      return getProduct(item.handle).then(function (product) {
      var variant = null;
      if (item.variantId) {
        for (var i = 0; i < product.variants.length; i++) {
          if (String(product.variants[i].id) === String(item.variantId)) variant = product.variants[i];
        }
      }
      if (!variant) {
        for (var j = 0; j < product.variants.length; j++) {
          if (product.variants[j].available) { variant = product.variants[j]; break; }
        }
      }
      if (!variant) variant = product.variants[0];
      if (!variant) throw new Error('sin variante disponible');

      var full = variant.price;
      var pct = item.discountPercent || 0;
      /* Espejamos la cuenta de Shopify: redondea el MONTO del descuento y lo
         resta, no el precio final. 50% de 999 → descuento 500 → quedan 499
         ($4.99). Calcularlo al revés daría $5.00 y el popup mostraría un
         precio distinto al que se cobra.
         En modo 'variant' el precio rebajado ya es el de la variante. */
      var mode = item.mode || offer.mode || cfg.mode;
      var final = mode === 'variant' || !pct ? full : full - Math.round(full * pct / 100);
      if (item.finalPrice != null) final = item.finalPrice;

      return {
        choice: item,
        shortTitle: item.shortTitle,
        variantId: variant.id,
        offerImage: product.featured_image || (product.images && product.images[0]) || '',
        offerTitle: product.title || '',
        priceText: formatMoney(final),
        compareText: final < full ? formatMoney(full) : '',
      };
      });
    }

    if (offer.type === 'choices' && offer.choices && offer.choices.length) {
      return Promise.all(offer.choices.map(resolveProduct)).then(function (choices) {
        var selected = choices[0];
        return {
          offer: offer,
          choices: choices,
          selectedChoice: selected,
          priceText: selected.priceText,
          compareText: selected.compareText,
          triggerTitle: (addedItem && addedItem.product_title) || offer.triggerTitle || '',
          triggerImage:
            (addedItem && addedItem.image) ||
            (addedItem && addedItem.featured_image && addedItem.featured_image.url) ||
            '',
        };
      });
    }

    return resolveProduct(offer).then(function (resolved) {
      resolved.offer = offer;
      resolved.triggerTitle = (addedItem && addedItem.product_title) || offer.triggerTitle || '';
      resolved.triggerImage =
        (addedItem && addedItem.image) ||
        (addedItem && addedItem.featured_image && addedItem.featured_image.url) ||
        '';
      return resolved;
    });
  }

  function onItemAdded(e) {
    if (!cfg || !root || !root.hidden) return;
    if (cfg.oncePerSession !== false && alreadyShown()) return;
    var variantId = (e.detail || {}).variantId;
    if (!variantId) return;

    // Suspendemos la apertura del drawer mientras decidimos.
    patchDrawer();
    suppressDrawer = true;

    fetch(CART_URL, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var added = null;
        for (var i = 0; i < cart.items.length; i++) {
          if (String(cart.items[i].variant_id) === String(variantId)) { added = cart.items[i]; break; }
        }
        var offer = null;
        for (var j = 0; j < cfg.offers.length; j++) {
          if (matches(cfg.offers[j], added)) { offer = cfg.offers[j]; break; }
        }
        if (!offer) throw new Error('skip: sin oferta para este producto');
        var offeredHandles = offer.handle
          ? [offer.handle]
          : (offer.choices || []).map(function (choice) { return choice.handle; });
        var skip = (offer.skipIfInCart || []).concat(offeredHandles);
        if (cartHasAny(cart, skip)) throw new Error('skip: la oferta ya está en el carrito');
        return buildState(offer, cart, added).then(open);
      })
      .catch(function (err) {
        if (err && String(err.message).indexOf('skip') !== 0) console.warn('[atc-upsell]', err);
        suppressDrawer = false;
        openDrawer();
      });
  }

  /* ---------------- init ---------------- */

  function init() {
    root = document.querySelector('[data-atc-upsell]');
    if (!root) return;

    var cfgEl = document.getElementById('atc-upsell-config');
    if (!cfgEl) return;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    if (!cfg || !cfg.offers || !cfg.offers.length) return;

    els = {
      addedLabel: q('[data-atcu-added-label]'),
      eyebrow: q('[data-atcu-eyebrow]'),
      trust: q('[data-atcu-trust]'),
      close: q('[data-atcu-close]'),
      timerLabel: q('[data-atcu-timer-label]'),
      triggerTitle: q('[data-atcu-trigger-title]'),
      triggerImg: q('[data-atcu-trigger-img]'),
      title: q('[data-atcu-title]'),
      cover: q('[data-atcu-cover]'),
      choices: q('[data-atcu-choices]'),
      lib: q('.atcu__lib'),
      libPath: q('[data-atcu-lib-path]'),
      libMeta: q('[data-atcu-lib-meta]'),
      track: q('[data-atcu-track]'),
      compare: q('[data-atcu-compare]'),
      price: q('[data-atcu-price]'),
      badge: q('[data-atcu-badge]'),
      timer: q('[data-atcu-timer]'),
      clock: q('[data-atcu-clock]'),
      cta: q('[data-atcu-accept]'),
      ctaLabel: q('[data-atcu-cta-label]'),
      ctaPrice: q('[data-atcu-cta-price]'),
      decline: q('[data-atcu-decline]'),
      err: q('[data-atcu-err]'),
    };

    if (els.cta) els.cta.addEventListener('click', accept);
    if (els.choices) {
      els.choices.addEventListener('click', function (event) {
        var card = event.target.closest('[data-atcu-choice]');
        if (!card) return;
        selectChoice(parseInt(card.getAttribute('data-choice-index'), 10));
      });
    }
    Array.prototype.forEach.call(root.querySelectorAll('[data-atcu-dismiss]'), function (el) {
      el.addEventListener('click', decline);
    });

    document.addEventListener('cart:item-added', onItemAdded);
    patchDrawer();

    // Para probar sin comprar:  atcUpsell.preview()
    window.atcUpsell = {
      preview: function (index) {
        var offer = cfg.offers[index || 0];
        if (!offer) return;
        patchDrawer();
        suppressDrawer = true;
        buildState(offer, null, null).then(open).catch(function (e) { console.error('[atc-upsell]', e); });
      },
      close: function () { close({ openDrawer: false }); },
      config: function () { return cfg; },
    };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
